angular.module('app.study-context', [
    'app.entity.service',
    'gettext',
]);
